import { Component, OnInit , Output  } from '@angular/core';
import { Modelcores, Pjoint } from '../../../../entity/Pjoint';
import { Contact } from '../../../../entity/Contact';
import { Mails } from '../../../../entity/Mails';
import { Prospect } from '../../../../entity/prospect';
import { Message } from 'primeng/primeng';
import { Staff } from '../../../../entity/Staff';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { EventEmitter } from '@angular/core';
import { MailsService } from 'src/app/service/mails.service';
import { environment } from 'src/environments/environment';
import { Suivi } from 'src/app/entity/Suivi';
import { StaffService } from 'src/app/service/staff.service';
import { saveAs } from 'file-saver';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Client } from 'src/app/entity/exhibitor';
import { Delegate } from 'src/app/entity/Delegate';
import { DelegateService } from 'src/app/service/delegate.service';
 
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-compose-mail',
  templateUrl: './compose-mail.component.html',
  styleUrls: ['./compose-mail.component.scss']
})
export class ComposeMailComponent implements OnInit {
  objet: string;
  corp: string;
  toAll: String;
  isLogistique: boolean;
  selectedClient: Client;


  constructor(private mailsService: MailsService, private http: HttpClient,
    private userService: StaffService, private exhibitorService: ExhibitorService, private delegateService: DelegateService) { }

  ngOnInit() {
    //console.log('init' + this.mail);
    let idUser: number = +localStorage.getItem('idUser');
    this.userService.getStaff(idUser).subscribe(result => {
      this.user = result;

    })

    this.user = new Staff()

  }

  //.........................................Emailing ...../////////////////////////////////////////////////////////////////////
  mail: Mails;
  isModelMails;
  isModelPjoint;
  suiviProspect: Suivi;
  prospect: Prospect
  ismail: boolean;
  uploadedFiles: any[] = [];
  modelsPjoints: Pjoint[] = [];
  modelsCores: Modelcores[] = [];
  from: string;
  signature: string
  projet: string
  mailsDetail: string;
  msgs: Message[] = [];
  isCC: boolean;
  isBCC: boolean;
  isFrom: boolean;
  uploadUrl: String = environment.restApiCRM + 'mails/upload1';
  tto: String[];
  cc: String[];

  bcc: String[];
  user: Staff;

  height = 750
  width = 1100
  icon = 'fullscreen_exit'
  typeRepMail: string;
  selectedDelegate: Delegate;
  @Output() onMailSentProspect = new EventEmitter<Suivi>();
  prepareMailDraft(mails: Mails) {
    this.tto = [];
    this.cc = [];
    this.bcc = [];
    this.isCC = false;
    this.isBCC = false;


    if (mails.tto)
      this.tto = mails.tto.replace(' ', '').split(';');
    if (mails.bcc) {
      this.tto = mails.bcc.replace(' ', '').split(';');
      this.isBCC = true;
    }
    if (mails.cc) {
      this.tto = mails.cc.replace(' ', '').split(';');
      this.isCC = true;
    }


    this.mail = mails
    this.findModelsPjoint();
    this.findModelsCores()
    this.ismail = true
  }
  prepareReEmail(idMail: number, typeReply: string, projet: string, prospect: Prospect) {
    this.prospect = prospect;
    this.projet = projet;

    this.tto = [];
    this.cc = [];
    this.bcc = [];
    this.isBCC = false;
    this.isCC = false;


    this.mailsService.get(idMail).subscribe(mail => {
      mail.reply = typeReply

      this.replyMail(mail)
    })





    this.findModelsPjoint();
    this.findModelsCores()
    this.ismail = true
  }
  verifyConnection(mailAdresse: string, pass: string) {


    if (navigator.onLine) {
      this.mailsService.connect(mailAdresse, pass).subscribe(result => {
        let resSTR = JSON.stringify(result);
        let resJson = JSON.parse(resSTR);
        let resultat = resJson._body;


        if (resultat !== 'Connection successfuly') {

          alert('Vous étes hors connexion')
          //    localStorage.removeItem(mailAdresse);
          //   this.loginMailComponent.showLogin(mailAdresse);
          this.ismail = false;

        }
      })
    }
  }

  yes() {
    //console.log("dfdsfdsf");

  }
  prepareEmailLogistiques(toAll: string, projet: string, prospect: Prospect, objet: string, corp: string, client: Client) {
    this.objet = objet;
    this.corp = corp;
    this.toAll = toAll;
    this.isLogistique = true;
    this.selectedClient = client;
    //console.log("this.toAll" + this.toAll);

    this.prepareEmail(null, projet, prospect, [])
  }
  prepareEmailNormal(toAll: string, projet: string, prospect: Prospect,   client: Client) {
 
    this.toAll = toAll;
 
    this.selectedClient = client;
 
    this.prepareEmail(null, projet, prospect, [])
  }
  prepareEmailModel(modelCores: Modelcores, contact: Contact, projet: string, prospect: Prospect, uploadedFiles: any[]) {
    this.objet = modelCores.objet;
    this.corp = modelCores.corp;
    this.prepareEmail(contact, projet, prospect, uploadedFiles)
  }
  prepareEmailModelDelegate(modelCores: Modelcores, delegate: Delegate, uploadedFiles: any[]) {
    this.objet = modelCores.objet;
    this.corp = modelCores.corp;
    this.selectedDelegate = delegate;
    this.delegateService.sentDate(this.selectedDelegate).subscribe()
    this.prepareEmailDelegate(delegate, uploadedFiles)
  }

  prepareEmail(contact: Contact, projet: string, prospect: Prospect, uploadedFiles: any[]) {

    let mailAdresse: string;
    this.projet = projet;

    let pass: string;
    if (this.projet === 'HASSI') {
      mailAdresse = this.user.mailHassi;
      pass = this.user.passHassi;
      this.signature = this.user.signerHassi;

    }
    else {

      mailAdresse = this.user.mail;
      pass = this.user.mailpass;
      this.signature = this.user.signerMail;

      //console.log("pass" + pass);

    }



    if (pass) {
      this.ismail = true;
      this.mail = new Mails()




      this.mail.froma = mailAdresse;
      this.mail.pass = pass;
      this.prospect = prospect;
      this.projet = projet;
      this.uploadedFiles = uploadedFiles;

      this.tto = [];
      this.cc = [];
      this.bcc = [];
      this.isBCC = false;
      this.isCC = false;

      //console.log("contactcontact " + JSON.stringify(contact));
      if (this.toAll) {
        const cont = this.toAll.replace(/\s/g, "");


        this.tto = cont.split(';');

      }
      else if (contact && contact.mail) {
        const cont = contact.mail.replace(/\s/g, "");


        this.tto = cont.split(';');

      }




      this.mail.objet = this.objet
      this.mail.corp = this.corp + "<br />" + this.signature;


      this.mail.utilisateursMailsUserId = this.user
      //console.log(this.signature + " this.mail" + JSON.stringify(this.mail));


      this.mailsService.createDraft(this.mail).subscribe(result => {
        this.mail = result;


      })




      this.findModelsPjoint();
      this.findModelsCores();
      this.verifyConnection(mailAdresse, pass);
    }
    else {
      alert("erreur auth")
      //this.loginMailComponent.showLogin(mailAdresse);
    }

  }

  prepareEmailDelegate(delegate: Delegate, uploadedFiles: any[]) {

    let mailAdresse: string;

    let pass: string;
    if (this.projet === 'HASSI') {
      mailAdresse = this.user.mailHassi;
      pass = this.user.passHassi;
      this.signature = this.user.signerHassi;

    }
    else {

      mailAdresse = this.user.mail;
      pass = this.user.mailpass;
      this.signature = this.user.signerMail;

      //console.log("pass" + pass);

    }



    if (pass) {
      this.ismail = true;
      this.mail = new Mails()




      this.mail.froma = mailAdresse;
      this.mail.pass = pass;


      this.uploadedFiles = uploadedFiles;

      this.tto = [];
      this.cc = [];
      this.bcc = [];
      this.isBCC = false;
      this.isCC = false;


      if (this.toAll) {
        const cont = this.toAll.replace(/\s/g, "");
        //console.log("cont cont " + cont);

        this.tto = cont.split(';');

      }
      else if (delegate && delegate.mail) {
        const cont = delegate.mail.replace(/\s/g, "");
        //console.log("cont cont " + cont);

        this.tto = cont.split(';');

      }




      this.mail.objet = this.objet
      this.mail.corp = this.corp + "<br />" + this.signature;


      this.mail.utilisateursMailsUserId = this.user
      //console.log(this.signature + " this.mail" + JSON.stringify(this.mail));


      this.mailsService.createDraft(this.mail).subscribe(result => {
        this.mail = result;


      })




      this.findModelsPjoint();
      this.findModelsCores();
      this.verifyConnection(mailAdresse, pass);
    }
    else {
      alert("erreur auth")
      //this.loginMailComponent.showLogin(mailAdresse);
    }

  }

  editDraft() {


    this.mail.tto = this.tto.join(',');
    this.mail.cc = this.cc.join(',');

    this.mail.bcc = this.bcc.join(',');
    this.mailsService.editDraft(this.mail).subscribe(result => {
      this.show('Message copie to Draft', 'info')
    })
  }



  replyMail(mails: Mails) {



    this.tto = mails.froma.split(';');


    let re = " <br />On " + new Date(mails.dateAjout).toLocaleString() + " " + mails.froma
      + "  à ecrit :<blockquote style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div class=\"gmail_default\" style=\"font-family:verdana,sans-serif;font-size:small\">";
    let bk = "    </blockquote><br /><br />";
    let forward = "---------- Message transféré ----------<br /> De : " + mails.froma + "<br />Date :" + new Date(mails.dateAjout).toLocaleString() + "<br />" +
      "Objet :" + mails.objet + "<br /> À :" + mails.tto;

    this.mail = mails
    if (this.projet === 'HASSI') {
      this.signature = this.user.signerHassi;
      this.mail.froma = this.user.mailHassi;
      this.mail.pass = this.user.passHassi;
    }
    else {
      this.signature = this.user.signerMail;
      this.mail.froma = this.user.mail;
      this.mail.pass = this.user.mailpass;
    }



    if (this.mail.reply == "RE") {

      this.mail.corp = re + mails.corp + bk;
    }
    else {
      this.mail.corp = forward + "<br />" + mails.corp;

      this.pjointsMail(mails);

    }
    this.mail.idMails = null
    this.mail.utilisateursMailsUserId = this.user


    this.mail.objet = this.mail.reply + ": " + mails.objet;

    this.mail.corp += this.signature;
    this.mailsService.createDraft(this.mail).subscribe(result => {
      this.mail = result;
    })
  }
  createSuivi() {
    if (this.isLogistique) {
//console.log("edit client");

      this.editClient()
    }
    else {
      this.suiviProspect = new Suivi();
      this.suiviProspect.possibilteSignature = "d";
      this.suiviProspect.prospect = this.prospect;
      this.suiviProspect.commentaire = this.mail.objet;

      this.suiviProspect.idMail = this.mail.idMails
      this.suiviProspect.title = 'Envoi Mail'


      this.onMailSentProspect.emit(this.suiviProspect)
    }
  }

  editClient() {

    this.exhibitorService.editLogistiques(this.selectedClient.idClient).subscribe()

  }
  toggle() {
    this.ismail = false;
    if (this.height > 50) {
      this.height = 10;
      this.width = 100;
      this.icon = 'fullscreen'
    }
    else {
      this.icon = 'fullscreen_exit'
      this.height = 750
      this.width = 1100
      if (window.innerHeight < 800)
        this.height = window.innerHeight - 100
    }
    setTimeout(() => {
      this.ismail = true;
    }, 100);
    // this.ismail=true;

  }
  sendEmail() {

    this.mail.tto = this.tto.join(',');
    this.mail.cc = this.cc.join(',');
    this.mail.utilisateursMailsUserId = this.user
    this.mail.bcc = this.bcc.join(',');




    var fd = new FormData();

    for (let file of this.uploadedFiles) {

      //console.log('file.name' + file.name);

      let fileName = 'file.pdf';
      if (file.name)
        fileName = file.name;

      fd.append("file", file, fileName);

    }

    this.mailsService.editDraft(this.mail).subscribe(result => {

      this.mail = result;
      fd.append("mail", JSON.stringify(this.mail));



      this.mailsService.upload(fd).subscribe(result => {
        let resSTR = JSON.stringify(result);
        let resJSON = JSON.parse(resSTR);
        this.show(resJSON._body, 'success');
        if (resJSON._body.includes("Sent")) {
          this.createSuivi()

        }

  

        window.alert(JSON.stringify(resJSON._body));

      }
        , error => {
          if (error.error.text.includes("Sent")) {
            this.createSuivi()
  
          }
      
          this.show(error.error.text, 'error');
          window.alert( error.error.text);
          //console.log("error " + JSON.stringify(error));
        }
      )
    });




    this.ismail = false;
  }
  file: File;
  removePJ(file: File) {
    let filesTemp: any[] = [];
    this.uploadedFiles.forEach(element => {
      if (element !== file)
        filesTemp.push(element);
    });
    this.uploadedFiles = filesTemp;
  }
  onUpload1(event) {

    for (let file of event.files) {

      this.uploadedFiles.push(file);
//console.log("uploaded "+JSON.stringify( this.uploadedFiles.length));

    }
  }
  onUpload(event) {
    this.mail.tto = this.tto.join(',');
    var fd = new FormData();

    for (let file of event.files) {
      //console.log('file.name' + file.name);
      fd.append("file", file, 'dsfsdf.pdf');

    }
    fd.append("mail", JSON.stringify(this.mail));

    this.mailsService.upload(fd).subscribe(result => {
      let resSTR = JSON.stringify(result);
      let resJSON = JSON.parse(resSTR);
      this.show(resJSON._body, 'success');

    })

  }



  findModelsPjoint() {
    this.mailsService.modelPjoints().subscribe(result => {
      this.modelsPjoints = [];
      let projet = "HME";
      if ("NAPEC" === this.projet)
        projet = "NAPEC";


      result.forEach(element => {

         
          this.modelsPjoints.push(element)
      });

    });
  }
  findModelsCores() {
    this.mailsService.modelsCorespAll().subscribe(result => {
      this.modelsCores = result;
    });
  }
  onChooseModel(modelPjoint: Pjoint) {
    this.mailsService.pjointFile(modelPjoint).subscribe(res => {
      res.name = modelPjoint.fileName
      // //console.log(res);

      this.uploadedFiles.push(res);
    }

    );
  }
  pjointsMail(mails: Mails) {
    this.mailsService.mailPjoints(mails).subscribe(pjoints => {
      if (pjoints)
        pjoints.forEach(pjoint => {
          this.mailsService.pjointFile(pjoint).subscribe(res => {
            res.name = pjoint.fileName
            //console.log(res);

            this.uploadedFiles.push(res);
          }
          );


        });
    })


  }


  isContacts: boolean;

  selectContacts(contacts: Contact[]) {
    this.isContacts = false
    if (contacts)
      contacts.forEach(contact => {
        if (contact.mail && contact.mail.length > 5)
          this.tto.push(contact.mail)
      });
  }


  onChooseModelCores(modelCores: Modelcores) {
    this.mailsService.modelCoresp(modelCores).subscribe(res => {


      this.mail.corp = res.corp;
      this.mail.corp += "<br /><br /><br />" + this.signature;
      this.mail.objet = res.objet;

    }

    );
  }

  onChooseMails(mails: Mails) {
    this.mailsDetail = `<strong>FROM:</strong> ${mails.froma} <br /> <strong>To:</strong> ${mails.tto} <br /> <strong>CC:</strong> ${mails.cc} <br /> <strong>BCC:</strong> ${mails.bcc}<br /> <br /> `
    this.mailsDetail += `<strong>Objet:</strong> ${mails.objet} <br /><br />    `
    this.mailsDetail += ` ${mails.corp} <br /> `
    this.uploadedFiles = [];
    document.getElementById("demo").innerHTML = this.mailsDetail;
    this.pjointsMail(mails);

  }

  openFile(blob: any) {

    saveAs(blob, blob.name)
  }

  hide() {
    setTimeout(() => {
      this.msgs = [];

    }, 3000);

  }
  formatBytes(a, b) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }




  public CkeditorConfig = {

    language: 'fr',
    skin: 'office2013',
    cloudServices_tokenUrl: 'https://example.com/cs-token-endpoint',
    cloudServices_uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/',
    uiColor: '#9AB8F3',
    toolbarCanCollapse: false,
    disableNativeSpellChecker: false,
    allowedContent: true,
    scayt_autoStartup: true,
    scayt_sLang: 'fr_FR',
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',

    sharedSpaces: {
      top: 'headerConf',

    },

    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 400,

    toolbarGroups: [
      { name: 'spellchecker', groups: ['spellchecker'] },

      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph', 'forms', 'cleanup', 'mode'] },
      { name: 'editing', groups: ['find', 'selection'] },

      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },

      { name: 'basicstyles', groups: ['basicstyles'] },

      { name: 'links', groups: ['links'] },
      { name: 'document', groups: ['document'] },
      { name: 'insert' },
    ],

    removeButtons: 'NewPage  ,Textarea,Select,Button,ImageButton,HiddenField',
    protectedSource: [/{{[\s\S]*?}}/g],
    extraPlugins: 'sharedspace,easyimage'
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
    // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

  }

  public CKEDITOR = [];

  clickSend() {

  }
  browse() {

    document.querySelectorAll('input[type=file]')[0]['click']();
  }
  show(message: string, sever: string) {
    this.msgs.push({ severity: sever, summary: 'Alert', detail: message });

    this.hide();
  }

  public requestAutocompleteItems = (mailAdd: string): Observable<Response> => {
    const url = environment.restApiCRM + `mailsFunc` + '/findMailAdresseTo/' + this.mail.froma + '/' + mailAdd;
    //console.log('fff');


    return this.http
      .get<Response>(url);
  };
}
